let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8TdZh")).then(() => parcelRequire('4f1t8'));